export const badgesKeys = {
  mine: ["badges"] as const,
};
